import type { ElectronContext } from '@mimir/common/context/applicationContext';

export const getElectronIpcRenderer = (applicationContext: ElectronContext) => {
  if (window.mimirElectron.ipcRenderer) {
    // For newer Mimir Desktop
    return window.mimirElectron.ipcRenderer;
  }

  // Fallback to old ways
  const req = applicationContext.rendererRequire;
  if (!req) {
    return;
  }
  return req('electron').ipcRenderer;
};
